var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAudio = function SvgAudio(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 140,
    viewBox: "0 0 296 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7277_6733)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 295,
    height: 139,
    rx: 2.5,
    fill: "#F5F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.333 51.333L132 61.9997H121.333V77.9997H132L145.333 88.6663V51.333Z",
    stroke: "#8D83FB",
    strokeWidth: 3.54667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.853 51.1465C171.853 56.1472 174.661 62.9288 174.661 69.9998C174.661 77.0709 171.853 83.8524 166.853 88.8532M157.44 60.5598C159.94 63.0602 161.344 66.451 161.344 69.9865C161.344 73.522 159.94 76.9128 157.44 79.4132",
    stroke: "#8D83FB",
    strokeWidth: 3.54667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 295,
    height: 139,
    rx: 2.5,
    stroke: "#8D83FB",
    strokeDasharray: "4.5 4.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7277_6733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 296,
    height: 140,
    rx: 3,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAudio);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjk2IiBoZWlnaHQ9IjE0MCIgdmlld0JveD0iMCAwIDI5NiAxNDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF83Mjc3XzY3MzMpIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIyOTUiIGhlaWdodD0iMTM5IiByeD0iMi41IiBmaWxsPSIjRjVGNUZGIi8+CjxwYXRoIGQ9Ik0xNDUuMzMzIDUxLjMzM0wxMzIgNjEuOTk5N0gxMjEuMzMzVjc3Ljk5OTdIMTMyTDE0NS4zMzMgODguNjY2M1Y1MS4zMzNaIiBzdHJva2U9IiM4RDgzRkIiIHN0cm9rZS13aWR0aD0iMy41NDY2NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNjYuODUzIDUxLjE0NjVDMTcxLjg1MyA1Ni4xNDcyIDE3NC42NjEgNjIuOTI4OCAxNzQuNjYxIDY5Ljk5OThDMTc0LjY2MSA3Ny4wNzA5IDE3MS44NTMgODMuODUyNCAxNjYuODUzIDg4Ljg1MzJNMTU3LjQ0IDYwLjU1OThDMTU5Ljk0IDYzLjA2MDIgMTYxLjM0NCA2Ni40NTEgMTYxLjM0NCA2OS45ODY1QzE2MS4zNDQgNzMuNTIyIDE1OS45NCA3Ni45MTI4IDE1Ny40NCA3OS40MTMyIiBzdHJva2U9IiM4RDgzRkIiIHN0cm9rZS13aWR0aD0iMy41NDY2NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxyZWN0IHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMjk1IiBoZWlnaHQ9IjEzOSIgcng9IjIuNSIgc3Ryb2tlPSIjOEQ4M0ZCIiBzdHJva2UtZGFzaGFycmF5PSI0LjUgNC41Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNzI3N182NzMzIj4KPHJlY3Qgd2lkdGg9IjI5NiIgaGVpZ2h0PSIxNDAiIHJ4PSIzIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";